import { Injectable, NgZone } from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { KeyValueStoreService } from './key-value-store.service';
import { AppLogStorage } from '@model/database/app-log-storage';
import { AppLog } from '@model/database/app-log';
import { UtilService } from './util.service';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class AppLogsService {
  logStoreTable: LocalForage;
  intervalSource = interval(20 * 60 * 1000); // every 20 mins
  intervalSubscription: Subscription;

  constructor(
    private zone: NgZone,
    private keyValueStoreService: KeyValueStoreService
  ) {
    this.initLogStoreTable();
    this.clearOldRecords();
  }

  initLogStoreTable(): void {
    this.logStoreTable = this.keyValueStoreService.createTable('logs', 'log_store');
  }

  insertLog(appLog: AppLog): void {
    this.keyValueStoreService.set(this.logStoreTable, appLog.epochTime, appLog);
  }

  clearOldRecords(): void {
    this.intervalSubscription?.unsubscribe();

    this.zone.runOutsideAngular(() => {
      this.intervalSubscription = this.intervalSource.subscribe(async () => {
        try {
          const pastWeek = (new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toString();
          this.keyValueStoreService.listKeys(this.logStoreTable).then(keys => {
            (keys || []).forEach(key => {
              this.keyValueStoreService.get(this.logStoreTable, key).then((value: AppLogStorage) => {
                if (+value.epochTime < +pastWeek) {
                  this.keyValueStoreService.remove(this.logStoreTable, key).then(() => {
                    UtilService.logInfo(['Successfully deleted older log records.']);
                  });
                }
              });
            });
          });
        } catch (error) {
          UtilService.logError(['Failed to delete older log records:', error]);
        }
      });
    });
  }
}
